import Api from './Api';

export default {
    index() {
        return Api.get('/users');
    },
    consultants() {
        return Api.get('/users/consultants');
    },
    view(id) {
        return Api.get('/users/' + id);
    },
    add(data) {
        return Api.post('/users', data);
    },
    edit(id, data) {
        return Api.put('/users/' + id, data);
    },
    delete(id) {
        return Api.delete('/users/' + id);
    },
    ldap_search(query) {
        return Api.get('/users/ldap_search', {
            params: {
                query: query
            }
        });
    },
    profile() {
        return Api.get('/users/profile');
    },
    editProfile(id, data) {
        return Api.put('/users/editProfile' + id, data);
    },
    register(data) {
        return Api.post('/users/register', data);
    },
    registerCaptchaUri() {
        return Api.getUri({ url: 'users/registerCaptcha' });
    },
    my_consultant() {
        return Api.get('/users/my_consultant');
    },
    search(query) {
        return Api.get('/users/search', {
            params: {
                query: query
            }
        })
    }
}
